var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: { id: "lender-note-modal" },
    on: { show: _vm.handleShow, hidden: _vm.handleHidden },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("direct-to-lender.lenderSubmit.lenderNote")) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.modalOpened
              ? [
                  _c("div", { staticClass: "note-container py-3" }, [
                    _c("pre", { staticStyle: { "white-space": "pre-wrap" } }, [
                      _vm._v(_vm._s(_vm.currentLenderNote)),
                    ]),
                  ]),
                ]
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }